export const state = () => ({
  item: false,
  edit: false,
  steps: false,
  terms: false,
  gallery: false,
  instance: 0,
  currentStep: 0,
  galleryIndex: 0,
  modals: [],
  totalOptions: 0,
  settings: false,
  freeShippingTerms: false,
  isBundle: false,
  isAutoBundle: false,
  isQV: false,
  bundleSavings: [],
  components: [],
  promoReady: false,
  secondaryItems: [],
  secondaryItemsOptions: null,
  assistedScroll: false,
  scrollPosition: 0,
  evergreenSwatchCount: false,
  hiddenOptions: [],
  shopTheLook: [],
  selected: {
    quantity: 1,
    matches: [],
    options: [],
    components: [],
    gallery: false,
    variant: false,
    available: true,
    bundleUnavailable: false,
  },
  upsell: {
    items: [],
    loaded: false,
    overwritten: false,
    allow_overwrite: false,
  },
  upgrade: null,
  settings: {
    max_inventory: 10,
  },
});
